import * as React from 'react'
import { useState } from 'react'
import { styled } from '@/src/stitches.config'
import { ClipLoader } from 'react-spinners'

const StyledClipLoader = styled(ClipLoader, {
    position: 'fixed',
    top: '50%',
    left: '49%',
})

const StonlyContent = () => {
    const [isLoading, setIsLoading] = useState(true)

    return (
        <>
            {isLoading && <StyledClipLoader size={30} color={'black'} />}
            <iframe
                allowFullScreen={true}
                src="https://perfectgift.stonly.com/kb/guide/en/how-to-use-your-gift-Mh2gZw5TL3/Steps/2486190"
                width={'100%'}
                height={630}
                onLoad={() => {
                    setIsLoading(false)
                }}
            />
        </>
    )
}

export default StonlyContent
